export default __webpack_public_path__ + "static/media/March2023.43e2d878.png";